//Подтягивание главного банера по высоте хедера
function adjustBannerOffset() {
  const header = document.querySelector('header');
  const banner = document.querySelector('#Banner-template--24667060764997__image_banner');

  if (header && banner) {
    const headerHeight = header.offsetHeight;
    // Для ПК пристроїв (ширина > 900px)
    if (window.innerWidth > 900) {
      gsap.to(banner, {
        duration: 1,
        marginTop: '-' + headerHeight + 'px',
        paddingTop: headerHeight + 550 + 'px',
        ease: "expo.out"
      });
    } else {
      // Для мобільних пристроїв (ширина <= 900px)
      // Налаштуйте параметри відповідно до вашого дизайну для мобільної версії.
      gsap.to(banner, {
        duration: 1,
        marginTop: '-' + headerHeight + 'px',
        paddingTop: headerHeight + 'px',
        ease: "expo.out"
      });
    }
  }
}

// Викликати при завантаженні сторінки та зміні розміру вікна
window.addEventListener('load', adjustBannerOffset);
window.addEventListener('resize', adjustBannerOffset);


//Изменения фона шапки в зависимости от скролла на главной
document.addEventListener('DOMContentLoaded', () => {
  const stickyHeader = document.querySelector('sticky-header');
  const banner = document.querySelector('.banner');
  if (!stickyHeader || !banner) return;

  window.addEventListener('scroll', () => {
    if (window.pageYOffset === 0) {
      stickyHeader.classList.add('homepage-header');
    }
    else {
        stickyHeader.classList.remove('homepage-header');
      }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  gsap.registerPlugin(ScrollTrigger);

  gsap.from(".promo-text", {
    opacity: 0,
    y: 20,
    duration: 2,
    ease: "power2.out",
    stagger: 0.4,
    scrollTrigger: {
      trigger: ".promo-text",
      start: "top 80%",
      toggleActions: "play none none none"
    }
  });

    gsap.to(".promo-text", {
    color: "#058271", // Масив кольорів
    duration: 4, // Тривалість зміни кожного кольору
    repeat: -1, // Безкінечний цикл
    yoyo: true, // Повернення до початкового кольору
    ease: "power1.inOut"
  });
});

function replaceDesktopImage() {
  if (window.innerWidth > 900) {
    const bannerBlock = document.getElementById('Banner-template--24667060764997__image_banner');
    if (bannerBlock) {
      // Додаємо клас, який вимикає псевдоелемент ::before
      bannerBlock.classList.add('no-before');
      const bannerContentBlock = bannerBlock.querySelector('.banner__content--middle-center')
      bannerContentBlock.style.display = 'none';

      // Підміна зображення: змінюємо src та видаляємо srcset
      const img = bannerBlock.querySelector('.banner__media.media img');
      if (img) {
        gsap.set(img, { opacity: 0 });
        gsap.to(img, { duration: 0.5, opacity: 1, ease: "power1.out" });
        img.src = 'https://cdn.shopify.com/s/files/1/0804/4193/4149/files/ps5.png?v=1745520540';
        img.removeAttribute('srcset');
        img.onload = () => {
        };
      }

      bannerBlock.style.paddingTop = '540px';
    }
  }
}

document.addEventListener('DOMContentLoaded', replaceDesktopImage);

document.querySelector('.section-template--24667060928837__image_with_text_HARQem-padding').classList.remove('page-width');
document.querySelector('#ImageWithText--template--24667060928837__image_with_text_HARQem').classList.add('promo-text');